<template>
  <div v-if="isEnabledCancelDetail()">
    <div v-if="detailData.orderType == '企業検診'">
      <div v-for="(detail, index) in corpCancelDetails" :key="detail.value">
        <div class="detail-contents card-content margin-top">
          <div class="card-title">検査キャンセル情報{{ index + 1 }}</div>
          <table>
            <tr>
              <th>No.</th>
              <td>{{ detail.receptionNo }}</td>
            </tr>
            <tr>
              <th>被験者名</th>
              <td>{{ detail.patientName }}</td>
            </tr>
            <tr>
              <th>状態</th>
              <td>
                <div class="flex">
                  <div
                    class="status-card"
                    :class="getTabClass4RequestStatus(requestStatus.cancel)"
                  >
                    {{ getProgres(requestStatus.cancel) }}
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <th>キャンセル日時</th>
              <td>
                <p class="cancel-date">{{ detail.date }}</p>
              </td>
            </tr>
            <tr>
              <th>検査キャンセル理由</th>
              <td>
                <p class="cancel-text">{{ detail.memo }}</p>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>

    <div v-else class="detail-contents card-content margin-top">
      <div class="card-title">検査キャンセル情報</div>
      <table>
        <tr>
          <th>状態</th>
          <td>
            <div class="flex">
              <div
                class="status-card"
                :class="getTabClass4RequestStatus(requestStatus.cancel)"
              >
                {{ getProgres(requestStatus.cancel) }}
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <th>キャンセル日時</th>
          <td>
            <p class="cancel-date">{{ cancelDetail.date }}</p>
          </td>
        </tr>
        <tr>
          <th>検査キャンセル理由</th>
          <td>
            <p class="cancel-text">{{ cancelDetail.memo }}</p>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import { requestStatus } from "../../base/const.js";

const TYPE_COMPANY = "company";
const ERROR_MESSAGE_OBJ = { memo: "検査キャンセル情報を取得できませんでした" };

export default {
  data() {
    return {
      requestStatus,
      cancelDetail: {},
      corpCancelDetails: [],
    };
  },

  props: {
    detailData: {
      type: Object,
      default: {
        externalOperation: false,
        progress: 0,
        receiptNumber: "",
        orderType: "",
      },
    },
  },

  methods: {
    isEnabledCancelDetail() {
      return (
        this.detailData.externalOperation &&
        this.detailData.progress == requestStatus.cancel
      );
    },
    getCancelDetail() {
      if (this.isEnabledCancelDetail()) {
        let orderType = this.setOrderType();
        const THIS = this;

        this.apiCall(
          (client) => {
            return client.apis.externalRequestSearch.getHistoryDetail({
              body: {
                receptionNo: THIS.detailData.receiptNumber,
                orderType: orderType,
                status: requestStatus.cancel,
              },
            });
          },
          (result) => {
            if (orderType == TYPE_COMPANY) {
              THIS.corpCancelDetails = result.obj.historyDetailList;
            } else {
              THIS.cancelDetail = result.obj.historyDetail;
            }
          },
          (error) => {
            if (orderType == TYPE_COMPANY) {
              THIS.corpCancelDetails = [ERROR_MESSAGE_OBJ];
            } else {
              THIS.cancelDetail = ERROR_MESSAGE_OBJ;
            }
          }
        );
      }
    },

    setOrderType() {
      let orderType = this.detailData.orderType;
      switch (orderType) {
        case "企業検診":
          orderType = "company";
          break;
        default:
          break;
      }
      return orderType;
    },
  },

  created() {
    this.getCancelDetail();
  },
};
</script>

<style scoped>
.flex {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
}
.w-150 {
  width: 150px;
}
.card-title {
  font-size: 20px;
  margin-bottom: 0.5em;
}
.status-card {
  width: 120px !important;
  height: 30px !important;
}
.cancel-text {
  word-break: break-word;
}
</style>



// WEBPACK FOOTER //
// src/components/mock/common/components/CancelDetailPart.vue